export default "__VITE_ASSET__QsyBAmnt__"